module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_notifications-6f7286a645bb265048b1bda00398444c.png";